import { Skeleton } from 'antd';
import { pathOr, prop, sortBy } from 'ramda';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Button } from '@frontend/legacy-components';

import { fetchQuoteWorkflow } from './data/actions';
import { getIsFetchingQuoteWorkflow, getQuoteWorkflow } from './data/reducer';
import { open as openWorkflowModal } from './workflowModal/data/actions';
import { MODES as WORKFLOW_MODAL_MODES } from './workflowModal/data/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`;

const EmptyContainer = styled.div`
  background: ${({ theme }) => theme.color.page.plateLight};
  border: solid 1px ${({ theme }) => theme.color.separator.border};
  margin-bottom: 1rem;
  padding: 3rem;
`;

const EmptyMessage = styled.p`
  text-align: center;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-bottom: 1rem;
  }
`;

const StepsList = styled.ul`
  margin-bottom: 1rem;
`;

const StepListItem = styled.li`
  align-items: center;
  background: ${({ theme }) => theme.color.page.surface};
  border: 1px solid ${({ theme }) => theme.color.separator.divider};
  color: ${({ theme }) => theme.color.feature.primary};
  display: flex;
  justify-content: space-between;
  min-height: 50px;
  padding: 0 1rem;
  transition: 0.3s ease all;
  width: 100%;
  word-break: break-word;
  ${({ theme }) => theme.font.size.D}

  :not(:last-child) {
    border-bottom: 0;
  }
`;

const Title = styled.p`
  ${({ theme }) => theme.font.size.C}
  font-weight: ${({ theme }) => theme.font.weight.heavy};
  margin-bottom: 1rem;
`;

const sortByPosition = sortBy(prop('position'));

const connector = connect(
  (state, { isReadOnlyPermission }) => ({
    quoteWorkflow: getQuoteWorkflow(state),
    isFetchingQuoteWorkflow: getIsFetchingQuoteWorkflow(state),
    isReadOnlyPermission,
  }),
  {
    fetchQuoteWorkflow: fetchQuoteWorkflow.request,
    openWorkflowModal: openWorkflowModal.request,
  },
);

const QuoteWorkflowSteps = ({
  fetchQuoteWorkflow,
  isFetchingQuoteWorkflow,
  isReadOnlyPermission,
  openWorkflowModal,
  quoteWorkflow,
}) => {
  return (
    <Container>
      <Title>Quote Workflow Steps</Title>
      {isFetchingQuoteWorkflow ? (
        <LoadingContainer>
          <Skeleton.Input active size="larrge" />
          <Skeleton.Input active size="larrge" />
          <Skeleton.Input active size="larrge" />
        </LoadingContainer>
      ) : (
        <>
          <StepsList>
            {sortByPosition(pathOr([], ['steps'], quoteWorkflow)).map(
              (step) => (
                <StepListItem key={step.id}>
                  {pathOr('--', ['step', 'name'], step)}
                </StepListItem>
              ),
            )}
          </StepsList>
          {pathOr([], ['steps'], quoteWorkflow).length === 0 && (
            <EmptyContainer>
              <EmptyMessage>No Quote Workflow Steps</EmptyMessage>
            </EmptyContainer>
          )}
        </>
      )}
      <div>
        <Button
          variant="primary"
          isDisabled={isFetchingQuoteWorkflow || isReadOnlyPermission}
          onClick={() =>
            openWorkflowModal({
              callBack: fetchQuoteWorkflow,
              mode: quoteWorkflow
                ? WORKFLOW_MODAL_MODES.EDIT
                : WORKFLOW_MODAL_MODES.CREATE,
              workflowId: pathOr(null, ['id'], quoteWorkflow),
            })
          }
        >
          Edit
        </Button>
      </div>
    </Container>
  );
};

export default connector(QuoteWorkflowSteps);
